import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import ProcessSteps from '../components/ProcessSteps';

const PaymentCancel = () => {
  const { t } = useTranslation('payment');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bucketId = searchParams.get('bucket');

  const handleRetry = () => {
    if (bucketId) {
      navigate(`/invoice/${bucketId}`);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container mx-auto p-4 mt-16">
        <ProcessSteps currentStep={2} />
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
            <div className="text-center">
              <div className="mx-auto mb-4">
                <svg className="w-16 h-16 text-red-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('cancel.title')}</h2>
              <p className="text-gray-600 mb-8">{t('cancel.message')}</p>
              <div className="space-y-4">
                <button
                  onClick={handleRetry}
                  className="bg-green-500 text-white px-6 py-2 rounded hover:bg-green-600 transition-colors w-full"
                >
                  {t('cancel.tryAgain')}
                </button>
                <button
                  onClick={() => navigate('/')}
                  className="bg-gray-200 text-gray-700 px-6 py-2 rounded hover:bg-gray-300 transition-colors w-full"
                >
                  {t('cancel.returnHome')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;